<template>
    <span>
        <displaycardapio></displaycardapio>
    </span>
</template>

<script>
import Displaycardapio from '@/components/Display-Cardapio';

export default {
    name: 'caddisplaycardapio',
    components: {
        Displaycardapio
    }
};
</script>